// Inicializar al cargar la página
document.addEventListener("DOMContentLoaded", function(){
  function convertPricesTo(currency){
    document.querySelectorAll(".money").forEach(ev => {
      const base = parseFloat(ev.dataset.basePrice);
      const format = new Intl.NumberFormat("en-US", {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      if(!isNaN(base)){
        const convert = Currency.convert(base, "MXN", currency);
        const price = format.format(convert % 1 === 0 ? convert.toFixed(0) : convert.toFixed(2));
        ev.textContent = `$ ${price}`;
      }
    });
  }
  
  function convertPrices(price){
    const currency = localStorage.getItem("preferredCurrency") || "MXN";
      const base = parseFloat(price);
      const format = new Intl.NumberFormat("en-US", {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      if(!isNaN(base)){
        const convert = Currency.convert(base, "MXN", currency);
        const price = format.format(convert % 1 === 0 ? convert.toFixed(0) : convert.toFixed(2));
        return `$ ${price}`;
      }
  }
  
  function readyConvert(){
      // Guardar precio base si no está ya guardado
      document.querySelectorAll(".money").forEach(ev => {
        if(!ev.dataset.basePrice){
          const raw = parseFloat(ev.textContent.replace(/[^0-9.]/g, ""));
        }
      });
    
      // Aplicar moneda almacenada en localStorage
      const savedCurrency = localStorage.getItem("preferredCurrency") || "MXN";
      document.querySelector("#currencies").value = savedCurrency;
      convertPricesTo(savedCurrency);
  }
  
  // Cambiar moneda al seleccionar
  document.querySelector("#currencies").addEventListener("change", function(){
    const selectedCurrency = this.value;
    localStorage.setItem("preferredCurrency", selectedCurrency);
    convertPricesTo(selectedCurrency);
  });

  document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
    form.addEventListener('submit', () => {
      setTimeout(readyConvert, 1500); // da tiempo a que el DOM se actualice
    });
  });
  
  readyConvert();
})
